import { action } from 'typesafe-actions';
import { IAuthorizedMedia } from '../Search/Types';

import { IUserActionTypes } from './Types';

export const login = (username: string, password: string) => {
    return action(IUserActionTypes.LOGIN, [username, password])
};
export const getTokenPlayer = (music: boolean, readjusted: boolean, username: string) => {
    return action(IUserActionTypes.GET_TOKEN_PLAYER, [music, readjusted, username])
}
export const getTokenSuccess = (expires:number, token: string) => {
    return action(IUserActionTypes.GET_TOKEN_PLAYER_SUCCESS, [expires, token])
} 
export const logout = () => action(IUserActionTypes.LOGOUT);
export const loginSuccess = (username: string, token: string, expires: number, medias: IAuthorizedMedia[], user:any, have_right_show_total:boolean) =>
    action(IUserActionTypes.LOGIN_SUCCESS, [username, token, expires, medias, user, have_right_show_total]);
export const loginError = (message?:string) => action(IUserActionTypes.LOGIN_ERROR, message);

export const getAuthorizedMedias = (token: string) => {
    return action(IUserActionTypes.GET_AUTHORIZED_MEDIAS, token)
};
export const getAuthorizedMediasSuccess = (mediasTDP: IAuthorizedMedia[]) => {
    return action(IUserActionTypes.GET_AUTHORIZED_MEDIAS_SUCCESS, mediasTDP)
}
export const geAuthorizedtMediasError = (error: string) => {
    return action(IUserActionTypes.GET_AUTHORIZED_MEDIAS_ERROR, error)
}
export const saveExternalToken = (token: string) => action(IUserActionTypes.SAVE_EXTERNAL_TOKEN, token);
export const verifyExternalToken = () => action(IUserActionTypes.VERIFY_EXTERNAL_TOKEN);
export const verifyExternalTokenError = () => action(IUserActionTypes.VERIFY_EXTERNAL_TOKEN_ERROR);
export const verifyExternalTokenSuccess = (username: string, token: string, expires: number, user_id:number) =>
    action(IUserActionTypes.VERIFY_EXTERNAL_TOKEN_SUCCESS, [username, token, expires, user_id]);

export const createSchema = (token: string) => action(IUserActionTypes.CREATE_SCHEMA, token);
